interface GeoDebugPayload {
  [key: string]: boolean | number | string | null | undefined;
}

function isServerRuntime(): boolean {
  return typeof window === 'undefined';
}

export function isGeoDebugEnabled(): boolean {
  return isServerRuntime() && process.env.GEO_DEBUG === '1';
}

export function hashForGeoDebug(value: string): string {
  // FNV-1a 32-bit hash for stable, non-reversible debug keys.
  let hash = 0x811c9dc5;

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }

  return (hash >>> 0).toString(16).padStart(8, '0');
}

export function geoDebugLog(event: string, payload: GeoDebugPayload = {}): void {
  if (!isGeoDebugEnabled()) {
    return;
  }

  const logEntry = {
    tag: 'geo_debug',
    event,
    ts: new Date().toISOString(),
    ...payload,
  };

  console.log(JSON.stringify(logEntry));
}
